import { Icon, Button } from "@chakra-ui/react";
import { FaUndoAlt } from "react-icons/fa";

interface BackButtonProps {
  onClick: () => void;
}
export function BackButton({ onClick }: BackButtonProps) {
  return (
    <Button colorScheme="blue" variant="outline" onClick={onClick} mr="2">
      <Icon as={FaUndoAlt} mr="4px" />
      Voltar
    </Button>
  );
}
